<template>

	<div style="min-height: 75vh">
		<div class="container" v-if="!loadingOffers">
			<div class="d-flex flex-row flex-wrap" v-for="(offer, index) in completedOffers" :key="index">
				<CompletedOfferStatusTile :id="index" v-interact @cardClicked="handleCardClick"></CompletedOfferStatusTile>
			</div>
		</div>

		<div v-if="loadingOffers" class="container">
			<v-skeleton-loader :elevation="4" type="list-item-avatar-three-line,divider,list-item" v-for="n in 20"
				:key="n" color="var(--v-skeleton-loader-color)"></v-skeleton-loader>
		</div>

		<div class="d-flex justify-center" v-if="completedOffers.length === 0 && !loadingOffers">
			<EmptyList class="w-75 w-md-50 mt-4">
				<template v-slot:title>
					Sorry, you haven't completed any offers yet.
				</template>
			</EmptyList>
		</div>

		<!-- Offer Details Dialog -->  
		<OfferDetailsDialog :offer="selectedOffer.offer" :noStartButton="true" @report-offer="openReportOfferDialog">
			<OfferSupport :support_info="selectedOffer.support_info"></OfferSupport>
		</OfferDetailsDialog>

		<!-- Report Offer Dialog -->
		<ReportOfferDialog />
	</div>

	<v-row class="my-4">
		<v-col cols="12">
			<Pagination 
				:model-value="completedOfferStatusListPage"
				@update:model-value="(value) => completedOfferStatusListPage = value"
				:length="completedOfferStatusListPageLength" 
				:total-visible="totalVisible"
			/>
		</v-col>
	</v-row>
</template>



<script setup>

import { isMobile } from "@/utils/utils";
import { OfferStore } from "@/store/offerStore";
import { ref, computed, provide, onMounted } from "vue";
import EmptyList from "@/components/Common/Empty-List.vue";
import { OfferStatusStore } from "@/store/OfferStatusStore";
import Pagination from "@/components/Common/Pagination.vue";
import { usePagination } from "@/composables/usePagination";
import OfferSupport from '@/components/Offer/StartOfferDialogComponents/Offer-Support.vue';
import CompletedOfferStatusTile from "@/components/Tiles/Offer/Status/Completed-Offer-Status-Tile.vue";
import OfferDetailsDialog from '@/components/Offer/StartOfferDialogComponents/Offer-Details-Dialog.vue';
import ReportOfferDialog from '@/components/Offer/StartOfferDialogComponents/Report-Offer-Dialog.vue';

const offerStore = OfferStore();
const loadingOffers = computed(() => offerStore.loadingOffers);
const offerStatusStore = OfferStatusStore();
const offerDetailsDialogOpen = ref(false);
provide("offerDetailsDialogOpen", offerDetailsDialogOpen);

const reportOfferDialogOpen = ref(false);
provide("reportOfferDialogOpen", reportOfferDialogOpen);

// Selected offer for details dialog
const selectedOffer = computed(() => offerStatusStore.selectedOffer);

// Use the pagination composable to handle pagination logic
const { pageNumber: completedOfferStatusListPage, pageLength: completedOfferStatusListPageLength, totalVisible } = usePagination({
	store: offerStatusStore,
	getTotalPages: (store) => store.completedOffersPaging.totalPages,
	getCurrentPage: (store) => store.completedOffersPaging.page,
	setPage: (store, page) => store.setCompletedOffersPage(page),
	fetchData: async (store) => await store.getAllMyOffers()
});

const completedOffers = computed(() => offerStatusStore.completedOffers);

const handleCardClick = () => {
	offerDetailsDialogOpen.value = true;
};

const openReportOfferDialog = () => {
	offerDetailsDialogOpen.value = false;
	reportOfferDialogOpen.value = true;
};

onMounted(() => {
	offerStatusStore.getAllMyOffers();
});
</script>



<style scoped lang="scss">
@use "@/assets/scss/button-mixins" as button-mixins;
.container {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
	gap: 15px;
}

</style>
